<template>
  <v-list dense>
    <draggable
      v-model="services"
      :group="{ name: 'services', pull: 'clone', put: false }"
      @start="drag = true"
      @end="drag = false"
      :clone="clone"
    >
      <v-list-item v-for="service in services" :key="service.id">
        <v-list-item-avatar>
          <v-tooltip bottom z-index="300">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="24">
                <v-img v-if="service.imageURL" :src="service.imageURL"></v-img>
                <v-icon
                  v-else
                  v-text="supplierTypeIcon(supplier.serviceType)"
                ></v-icon>
              </v-avatar>
            </template>
            <v-container style="max-width: 500px">
              <v-row>
                <v-col cols="12">
                  <v-img contain :src="service.imageURL"></v-img>
                </v-col>
                <v-col cols="12">
                  <div v-html="service.description"></div>
                </v-col>
              </v-row>
            </v-container>
          </v-tooltip>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <v-tooltip bottom z-index="300">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ service.name }} </span>
              </template>
              {{ service.name }}
            </v-tooltip>
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn class="ma-0" text icon small>
            <v-icon>mdi-drag</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </draggable>
    <div v-if="debug">
      <code>services: {{ services }}</code>
    </div>
  </v-list>
</template>

<script>
import { removeGQLTypename } from "../../../../helpers";
import draggable from "vuedraggable";
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
const randomize = require("randomatic");
export default {
  name: "suppliers-search-supplier-item",

  props: {
    supplier: {
      type: Object,
      default: () => {},
    },
    dense: {
      type: Boolean,
      defaul: () => false,
    },
  },

  mixins: [SupplierTypeIconMixin],

  components: { draggable },

  data() {
    return {
      debug: false,
      services: this.supplier.services
        ? this.supplier.services.edges
            .map(removeGQLTypename)
            .map((item) => ({ ...item, supplierId: this.supplier.id }))
        : [],
    };
  },

  computed: {
    title() {
      return this.supplier.name ? this.supplier.name : "Supplier Name";
    },
  },

  methods: {
    clone(item) {
      const templateItem = {
        id: "VGVtcGxhdGVJdGVtLTU2NA==",
        uid: randomize("Aa0", 32),
        serviceType: this.supplier.serviceType,
        serviceName: item.name,
        stdOccupancy: item.stdOccupancy,
        maxOccupancy: item.maxOccupancy,
        serviceId: item.id,
        supplierId: item.supplierId,
        supplierName: this.supplier.name,
        day: 1,
        duration: 1,
        itemBuy: 0,
        itemSell: 0,
        adultBuy: 0,
        adultSell: 0,
        childBuy: 0,
        childSell: 0,
        currencyBuy: "",
        currencySell: "",
        rateTypeCode: "",
        customPricing: false,
        optional: false,
        included: true,
        extras:
          item.extras && item.extras.edges.length > 0
            ? item.extras.edges
                .map(removeGQLTypename)
                .filter((e) => e.isMandatory)
                .map((e) => ({
                  extraId: e.typeId,
                  name: e.name,
                  day: 1,
                  duration: 1,
                }))
            : [],
      };
      return templateItem;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/SuppliersSearchSupplierItem.vue